var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLaps = function SvgLaps(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m9 19.95-1.07-1.044 1.85-1.85H9q-2.714 0-4.607-1.898T2.5 10.547q0-2.715 1.893-4.607T9 4.047h6q2.714 0 4.607 1.893t1.893 4.607-1.893 4.611T15 17.056v-1.5q2.084 0 3.542-1.462T20 10.547t-1.458-3.542T15 5.547H9q-2.085 0-3.542 1.458Q4 8.462 4 10.547t1.458 3.562Q6.916 15.59 9 15.68h.92l-1.964-1.973L9 12.662l3.644 3.644z"
  })));
};
export default SvgLaps;